export const zindexes = {
  menu: 888,
  focus: 9999,
};
